import OrigTimeAgo from 'react-timeago';

export default OrigTimeAgo;
